import { HttpClient } from '@packages/core/http';
import { UpdateBatteryVin, VinResult } from '@packages/models/api';

export class EvBatteryService {
    constructor(private http: HttpClient) {}

    public validateBin = async ({
        binQrCode,
        ignoreCache = false,
        signal,
    }: {
        binQrCode: string;
        ignoreCache?: boolean;
        signal?: AbortSignal;
    }) => {
        return this.http.orchestrateRequest<any>({
            method: 'GET',
            url: `/battery/${binQrCode}/validate`,
            signal,
            ignoreCache,
        });
    };

    public postEvBatteryVin = async ({
        updatebatteryVinBody,
        ignoreCache = false,
        signal,
    }: {
        updatebatteryVinBody: UpdateBatteryVin;
        ignoreCache?: boolean;
        signal?: AbortSignal;
    }) => {
        return this.http.orchestrateRequest<VinResult>({
            method: 'POST',
            url: '/northstar/PostEVBatteryVIN',
            body: updatebatteryVinBody,
            ignoreCache,
            signal,
        });
    };
}
